
import { Permission, Resource, PermissionType, Role, Company } from "./types";

/**
 * R27: De vroegere "management heeft altijd toegang"-bypass is verwijderd.
 * Permissies worden nu UITSLUITEND uit role_permissions gelezen, ook voor
 * management/admin-rollen. De EXEMPT_FROM_MANAGEMENT_BYPASS-lijst is daarmee
 * overbodig geworden en is geschrapt.
 */

/**
 * Check if a role has permission for a resource and action within a specific company.
 * Geen role-based shortcuts meer — puur lookup in role_permissions.
 */
export const checkPermission = (
  permissions: Permission[],
  role: Role | undefined,
  resource: Resource,
  permissionType: PermissionType = "read",
  company: Company = "luijten_vvz"
): boolean => {
  if (!role) {
    console.log(`No role provided for permission check on ${resource}`);
    return false;
  }

  // Special case for feedback - read/write access for all roles (product-rule, niet rol-bypass)
  if (resource === "feedback" && (permissionType === "read" || permissionType === "write")) {
    return true;
  }

  const permission = permissions.find(
    p => p.role === role && p.resource === resource && p.company === company
  );

  if (!permission) {
    console.log(`No permission found for ${role} - ${resource} - ${company}`);
    return false;
  }

  const hasAccess = permission[permissionType] === true;
  console.log(`Permission check ${role}/${resource}/${permissionType}/${company}: ${hasAccess}`);
  return hasAccess;
};
